module.exports = __webpack_public_path__ + "static/media/red-cross.9ab12e8e.svg";